
import { Options, Vue } from 'vue-class-component';
import { ContextType, CourseInfo, Section, Team } from '@/models/CourseInfo';
import LoadingScreen from './LoadingScreen.vue';
import Tooltip from './Tooltip.vue';
import ConfirmDialog from './ConfirmDialog.vue';
import GroupSetWrapper from '@/models/GroupSetWrapper';
import SectionWrapper from '@/models/SectionWrapper';
import axios from 'axios';

@Options({
  props: {
    course: Object,
    team: Object,
    canBecomeOwner: Boolean
  },
  components: { LoadingScreen, ConfirmDialog, Tooltip }
})
export default class TeamEditor extends Vue {
  team!: Team;
  course!: CourseInfo;
  ContextType = ContextType;

  sections!: SectionWrapper[];
  groupSets!: GroupSetWrapper[];

  canBecomeOwner = false;

  isSaving = false;
  isDeleting = false;
  isOwnerDialog = false;

  created(): void {
    this.sections = this.course.sections.map(s => new SectionWrapper(this.team, s));
    this.groupSets = this.course.groupSets.map(s => new GroupSetWrapper(this.team, s));
  }

  save(): void {
    if (this.channelCount > 30) {
      alert('Too many private channels');
      return;
    }
    this.isSaving = true;
    if (this.team.contexts[0].type == ContextType.Section && this.team.contexts[0].id == -1) {
      this.team.contexts = this.team.contexts.slice(1);
    }

    if (!this.team.url) {
      if (this.team.createSectionChannels) {
        for (let sec of this.selectedSections) {
          this.team.channels.push({
            name: sec.name,
            contexts: [{ type: ContextType.Section, id: sec.id }]
          });
        }
      }

      this.course.teams.push(this.team);
      this.team.url = 'test';
    }
    axios.post('/CourseInfo', this.team).then(res => {
      this.isSaving = false;
      this.team.id = res.data;
      this.$emit('save');
    });
  }

  deleteTeam(): void {
    this.isDeleting = false;
    this.isSaving = true;
    axios.delete('/CourseInfo/' + this.team.id).then(res => {
      this.isSaving = false;
      this.$emit('delete');
    })
  }

  becomeOwner(): void {
    this.isOwnerDialog = false;
    this.isSaving = true;
    axios.post('/CourseInfo/BecomeOwner/' + this.team.id).then(res => {
      this.isSaving = false;
    })
  }

  get selectedSections(): Section[] {
    return this.team.contexts[0].type == ContextType.Course ? this.course.sections 
      : this.sections.filter(s => s.checked).map(s => s.section);
  }

  get channelCount(): number {
    return (this.team.createSectionChannels ? this.selectedSections.length : 0) 
      + this.groupSets.filter(g => g.checked).map(g => g.set.groupCount).reduce((a,b) => a+b, 0);
  }

  get isDuplicate(): boolean {
    return this.course.teams.filter(f => f.name == this.team.name && f !== this.team).length > 0;
  }

  get hasSectionChannels(): boolean {
    return this.team.channels && this.team.channels.filter(c => c.contexts.filter(z => z.type == ContextType.Section).length > 0).length > 0;
  }
}
